<swal
  #confirmSwal
  icon="question"
  confirmButtonText="Yes"
  cancelButtonText="Cancel"
></swal>

<swal
  #quantitySwal
  icon="question"
  input="number"
  confirmButtonText="Confirm"
  cancelButtonText="Cancel"
  [customClass]="{
    confirmButton: 'btn btn-primary',
    denyButton: 'btn btn-primary btn-outline',
    cancelButton: 'btn btn-neutral btn-outline',
  }"
></swal>
